import { gql } from "@apollo/client";

export const get_checkins = gql`
  query CheckIns(
    $where: CheckInWhereInput
    $orderBy: [CheckInOrderByWithRelationInput!]
    $take: Int
    $skip: Int
    $clinicMembersWhere2: ClinicMemberWhereInput
  ) {
    checkIns(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      clinic_id
      in_time
      created_at
      out_time
      status
      member_id
      member {
        name
        id
        clinic_members(where: $clinicMembersWhere2) {
          name
          clinic_id
        }
      }
      practitioner_id
      practitioner {
        name
        id
      }
      service_id
      service {
        name
        id
      }
      merchant_note
      booking {
        status
        service_helper {
          id
          name
        }
      }
      room {
        name
      }
      order_id
      isUsePurchaseService
    }
  }
`;

export const get_practitioner_checkins = gql`
  query CheckIns(
    $where: CheckInWhereInput
    $orderBy: [CheckInOrderByWithRelationInput!]
    $take: Int
    $skip: Int
    $clinicMembersWhere2: ClinicMemberWhereInput
    $practitionersWhere2: CheckInPractitionerWhereInput
  ) {
    checkIns(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      clinic_id
      in_time
      created_at
      out_time
      status
      member_id
      member {
        name
        id
        clinic_members(where: $clinicMembersWhere2) {
          name
          clinic_id
        }
      }
      practitioner_id
      practitioner {
        name
        id
      }
      service_id
      service {
        name
        id
      }
      merchant_note
      booking {
        status
        service_helper {
          id
          name
        }
      }
      room {
        name
      }
      order_id
      isUsePurchaseService
      practitioners(where: $practitionersWhere2) {
        id
        helper_id
        practitioner {
          id
          name
        }
        helper {
          id
          name
        }
      }
      helper {
        id
        name
      }
    }
  }
`;

export const get_checkins_count = gql`
  query AggregateCheckIn($where: CheckInWhereInput) {
    aggregateCheckIn(where: $where) {
      _count {
        _all
      }
    }
  }
`;

export const getCheckInsVar = (data: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  status?: string[] | string;
  searchText?: string | null;
  take: number;
  skip?: number;
}) => {
  const { status = [], searchText, skip = 0 } = data;
  let variables: any = {},
    where: any = {},
    OR: any[] = [];
  if (searchText && searchText !== "") {
    OR.push({
      member: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({
      practitioner: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({
      booking: {
        is: {
          OR: [
            {
              service_helper: {
                is: { OR: [{ name: { contains: searchText } }] },
              },
            },
          ],
        },
      },
    });
    OR.push({ service: { is: { OR: [{ name: { contains: searchText } }] } } });
  }
  where.clinic_id = { equals: data.clinicId };
  where.in_time = { gte: data.startDate, lte: data.endDate };
  variables.clinicMembersWhere2 = { clinic_id: { equals: data.clinicId } };
  if (status.length > 0) where.status = { in: status };
  if (OR.length > 0) where.OR = OR;
  variables.where = where;
  variables.orderBy = [{ created_at: "desc" }];
  variables.take = data.take;
  variables.skip = skip;
  return variables;
};

export const getPractitionerCheckInsVar = (data: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  status?: string[] | string;
  searchText?: string | null;
  take: number;
  skip?: number;
}) => {
  const { status = [], searchText, skip = 0 } = data;
  let variables: any = {},
    where: any = {},
    OR: any[] = [];
  if (searchText && searchText !== "") {
    OR.push({
      member: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({
      practitioner: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({
      booking: {
        is: {
          OR: [
            {
              service_helper: {
                is: { OR: [{ name: { contains: searchText } }] },
              },
            },
          ],
        },
      },
    });
    OR.push({ service: { is: { OR: [{ name: { contains: searchText } }] } } });
  }
  where.clinic_id = { equals: data.clinicId };
  where.in_time = { gte: data.startDate, lte: data.endDate };
  variables.clinicMembersWhere2 = { clinic_id: { equals: data.clinicId } };
  variables.practitionersWhere2 = {
    OR: [
      {
        practitioner_id: {
          not: {
            equals: null,
          },
        },
      },
      {
        helper_id: {
          not: {
            equals: null,
          },
        },
      },
    ],
  };
  if (status.length > 0) where.status = { in: status };
  if (OR.length > 0) where.OR = OR;
  variables.where = where;
  variables.orderBy = [{ created_at: "desc" }];
  variables.take = data.take;
  variables.skip = skip;
  return variables;
};

export const getHelperCheckInsVar = (data: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  status?: string[] | string;
  searchText?: string | null;
  take: number;
  skip?: number;
}) => {
  const { status = [], searchText, skip = 0 } = data;
  let variables: any = {},
    where: any = {},
    OR: any[] = [];
  if (searchText && searchText !== "") {
    OR.push({
      member: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({
      practitioner: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({
      booking: {
        is: {
          OR: [
            {
              service_helper: {
                is: { OR: [{ name: { contains: searchText } }] },
              },
            },
          ],
        },
      },
    });
    OR.push({ service: { is: { OR: [{ name: { contains: searchText } }] } } });
  }
  where.clinic_id = { equals: data.clinicId };
  where.in_time = { gte: data.startDate, lte: data.endDate };
  
  const helperFilter = {
    OR: [
      {
        practitioners: {
          some: {
            helper_id: {
              not: {
                equals: null,
              },
            },
          },
        },
      },
      {
        helper_id: {
          not: {
            equals: null,
          },
        },
      },
    ],
  };
  
  if (OR.length > 0) {
    where.AND = [
      { OR: OR },
      helperFilter,
    ];
  } else {
    where.AND = [helperFilter];
  }
  
  variables.clinicMembersWhere2 = { clinic_id: { equals: data.clinicId } };
  variables.practitionersWhere2 = {
    OR: [
      {
        practitioner_id: {
          not: {
            equals: null,
          },
        },
      },
      {
        helper_id: {
          not: {
            equals: null,
          },
        },
      },
    ],
  };
  if (status.length > 0) where.status = { in: status };
  variables.where = where;
  variables.orderBy = [{ created_at: "desc" }];
  variables.take = data.take;
  variables.skip = skip;
  return variables;
};

export const get_members_checkin_count = gql`
  query GroupByCheckIn(
    $by: [CheckInScalarFieldEnum!]!
    $where: CheckInWhereInput
  ) {
    groupByCheckIn(by: $by, where: $where) {
      _count {
        _all
      }
      member_id
      clinic_id
    }
  }
`;
export const getMembersCheckInCountVar = (data: {
  clinicId: string;
  memberIds?: string[];
  startDate: Date;
  endDate: Date;
}) => {
  let variables: any = {};
  variables.by = ["clinic_id", "member_id"];
  variables.where = {
    clinic_id: { equals: data.clinicId },
    in_time: { gte: data.startDate, lte: data.endDate },
    ...(data.memberIds ? { member_id: { in: data.memberIds } } : {}),
  };
  return variables;
};

export const create_one_checkin = gql`
  mutation CreateOneCheckIn($data: CheckInCreateInput!) {
    createOneCheckIn(data: $data) {
      id
    }
  }
`;
export const getCreateOneCheckInVar = (data: {
  clinicId: string;
  practitionerId: string;
  serviceId: string;
  memberId: string;
  userId: string;
  inTime: Date;
  outTime: Date;
}) => {
  let variables: any = {};
  const clinic = { connect: { id: data.clinicId } };
  const practitioner = { connect: { id: data.practitionerId } };
  const service = { connect: { id: data.serviceId } };
  const member = { connect: { id: data.memberId } };
  const user = { connect: { id: data.userId } };
  const in_time = data.inTime;
  const out_time = data.outTime;
  const status = "CHECKOUT";
  variables.data = {
    in_time,
    out_time,
    status,
    clinic,
    service,
    practitioner,
    member,
    user,
  };
  return variables;
};

export const get_one_check_in = gql`
  query GetCheckIn(
    $where: CheckInWhereUniqueInput!
    $clinicMembersWhere2: ClinicMemberWhereInput
  ) {
    getCheckIn(where: $where) {
      id
      status
      created_at
      in_time
      out_time
      merchant_note
      clinic_id
      isUsePurchaseService
      service_id
      service {
        id
        name
      }
      booking_id
      booking {
        from_time
        to_time
        status
      }
      member {
        id
        name
        clinic_members(where: $clinicMembersWhere2) {
          name
        }
      }
      images {
        id
        name
        note
        image
      }
      practitioner {
        id
        name
      }
      room {
        name
      }
      order_id
    }
  }
`;
export const getOneCheckInVar = (id: string, clinicId: string) => ({
  where: { id },
  clinicMembersWhere2: { clinic_id: { equals: clinicId } },
});

export const update_one_checkin = gql`
  mutation UpdateOneCheckIn(
    $data: CheckInUpdateInput!
    $where: CheckInWhereUniqueInput!
  ) {
    updateOneCheckIn(data: $data, where: $where) {
      id
    }
  }
`;
export const getUpdateOneCheckInVar = (id: string) => ({ where: { id } });

export const delete_one_checkin = gql`
  mutation DeleteOneCheckIn($where: CheckInWhereUniqueInput!) {
    deleteOneCheckIn(where: $where) {
      id
    }
  }
`;
export const getDeleteOneCheckInVar = (id: string) => ({ where: { id } });

export const get_checkin_out_data = gql`
  query CheckInOutData(
    $where: CheckInWhereInput
    $orderBy: [CheckInOrderByWithRelationInput!]
    $take: Int
    $skip: Int
    $clinicMembersWhere2: ClinicMemberWhereInput
  ) {
    checkIns(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      in_time
      out_time
      status
      created_at
      isUsePurchaseService
      merchant_note
      order_id
      service {
        name
        id
      }
      practitioner {
        name
        id
      }
      member {
        name
        phonenumber
        clinic_members(where: $clinicMembersWhere2) {
          name
          phonenumber
          clinic_id
        }
      }
      room {
        name
      }
      booking {
        service_helper {
          id
          name
        }
      }
      orders {
        order_id
        discount
        tax
        total
        net_total
        payment_method
        payment_status
        seller {
          display_name
        }
        metadata
      }
      helper {
        name
      }
      practitioners {
        practitioner_id
        practitioner {
          id
          image
          name
        }
        helper_id
        helper {
          id
          name
        }
      }
    }
  }
`;

export const getCheckInOutDataVar = (data: {
  startDate: Date;
  endDate: Date;
  clinicId: string;
  paymentStatus?: string | null;
  status?: string[] | string;
  searchText?: string | null;
  orderBy?: Array<{ [key: string]: string }>;
  take?: number;
  skip?: number;
}) => {
  const { startDate, endDate, clinicId, paymentStatus, status, searchText, orderBy, take, skip } = data;
  
  const where: any = {
    AND: [
      {
        booking: {
          is: {
            from_time: {
              gte: startDate,
            },
          },
        },
      },
      {
        booking: {
          is: {
            from_time: {
              lte: endDate,
            },
          },
        },
      },
      {
        clinic_id: {
          equals: clinicId,
        },
      },
      {
        orders: {
          is: {
            status: {
              notIn: "CANCEL",
            },
          },
        },
      },
    ],
  };

  if (status && (Array.isArray(status) ? status.length > 0 : status)) {
    const statusArray = Array.isArray(status) ? status : [status];
    where.AND.push({
      status: {
        in: statusArray,
      },
    });
  }

  if (searchText && searchText !== "") {
    where.OR = [
      {
        member: {
          is: {
            OR: [
              { name: { contains: searchText } },
              { phonenumber: { contains: searchText } },
            ],
          },
        },
      },
      {
        practitioner: {
          is: {
            OR: [
              { name: { contains: searchText } },
              { phonenumber: { contains: searchText } },
            ],
          },
        },
      },
      {
        booking: {
          is: {
            service_helper: {
              is: {
                name: { contains: searchText },
              },
            },
          },
        },
      },
      {
        service: {
          is: {
            name: { contains: searchText },
          },
        },
      },
      {
        orders: {
          is: {
            order_id: {
              contains: searchText,
            },
          },
        },
      },
    ];
  }

  // Add payment status filter only if provided
  if (paymentStatus != null) {
    where.AND.push({
      orders: {
        payment_status: {
          equals: paymentStatus,
        },
      },
    });
  }

  const variables: any = {
    where,
    clinicMembersWhere2: {
      clinic_id: {
        equals: clinicId,
      },
    },
  };

  variables.orderBy = orderBy || [{ in_time: "desc" }, { id: "asc" }];

  // Add take and skip if provided
  if (take != null) {
    variables.take = take;
  }
  if (skip != null) {
    variables.skip = skip;
  }

  return variables;
};
